var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBagDone = function SvgShoppingBagDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.64 10.348H22.6a2.637 2.637 0 0 1 2.609 3.04l-1.656 10.756A3.96 3.96 0 0 1 19.64 27.5h-9.041a3.96 3.96 0 0 1-3.912-3.356L5.03 13.388a2.64 2.64 0 0 1 2.608-3.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.16 14.306V7.708a3.958 3.958 0 0 1 7.917 0v6.598M11.25 20.625l3.125 2.5L18.75 17.5"
  })));
};
export default SvgShoppingBagDone;